const api = {
    CustomerAutoRefund: '/open/common/customer/refund/autoRefund',
}

export default api